import React from 'react';

const ListJuriIIT2024: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-2xl font-semibold mb-4">🎓 Panel Juri IIT Challenge 2024</h2>
            <p className="mb-4">
                Di balik suksesnya berbagai kompetisi di <b>IIT Challenge 2024</b>, terdapat peran penting para juri yang telah berdedikasi menilai karya dan performa peserta dengan objektif dan profesional. Mereka berasal dari latar belakang akademisi, praktisi industri, hingga pelaku inovasi teknologi yang membawa perspektif luas dalam proses penilaian.
            </p>

            <h3 className="text-xl font-semibold mb-2">✨ Siapa Saja Mereka?</h3>
            <ul className="list-decimal pl-6 space-y-4">
                <li>
                <p className="font-semibold">Matius Kelvin, S.Kom., M.M., C.T – Panelis Symposium</p>
                <ul className="list-disc pl-6">
                    <li>Pendiri & Praktisi Indonesia Innovative Technology, PT. Accelist Lentera Indonesia, dan PT. Accelist Edukasi Indonesia</li>
                    <li>Innovation and Entrepreneurship Expert Judges Bina Nusantara University</li>
                </ul>
                </li>
                <li>
                <p className="font-semibold">Markus Fresnel, S.Kom., M.M., C.T – Panelis Symposium</p>
                <ul className="list-disc pl-6">
                    <li>Pengurus harian bidan II: Digitalisasi Pembelajaran MPK Indonesia</li>
                    <li>Global Learning System Partner – Bina Nusantara University</li>
                    <li>Business Mentor – Bina Nusantara University</li>
                </ul>
                </li>
                <li>
                <p className="font-semibold">Dr. Ir. Oki Sunardi, S.T. M.M., IPN, ASEAN Eng. – Panelis Symposium</p>
                <ul className="list-disc pl-6">
                    <li>Vice Rector Pengembangan Akademik dan Innovasi UKRIDA</li>
                    <li>Spesialis manajemen pengetahuan, optimisasi supply chain, efisiensi industry, dan integrasi teknologi</li>
                </ul>
                </li>
                <li>
                <p className="font-semibold">Ir. Eddy Wijanto, S.T., M.T., Ph.D., IPM – Panelis Innovative Technology Challenge</p>
                <ul className="list-disc pl-6">
                    <li>Dekan Fakultas Teknik & Ilmu Komputer UKRIDA</li>
                </ul>
                </li>
                <li>
                <p className="font-semibold">Burhan Sabini, M.Sc. – Panelis Innovative Technology Challenge</p>
                <ul className="list-disc pl-6">
                    <li>Dosen Fakultas Teknik dan Ilmu Komputer UKRIDA</li>
                </ul>
                </li>
                <li>
                <p className="font-semibold">Dr. Ir. Wahidin Wahab, M.Sc. – Panelis Innovative Technology Challenge</p>
                <ul className="list-disc pl-6">
                    <li>Dosen Teknik Elektro Universitas Indonesia & Universitas Tarumanegara</li>
                </ul>
                </li>
                <li>
                <p className="font-semibold">Tie Tieantono, S.Kom. – Panelis Coding Python</p>
                <ul className="list-disc pl-6">
                    <li>Owner Accelist Edukasi Indonesia</li>
                </ul>
                </li>
                <li>
                <p className="font-semibold">Roberto, S.Kom. – Panelis Coding Python</p>
                <ul className="list-disc pl-6">
                    <li>Chief Principal Engineer PT. Accelist Lentera Indonesia</li>
                </ul>
                </li>
                <li>
                <p className="font-semibold">Kevin Sutanto, S.T., M.Sc. – Panelis Sumo Games</p>
                <ul className="list-disc pl-6">
                    <li>Dosen Teknik Elektro UKRIDA</li>
                    <li>Falkultas Teknik dan Ilmu Komputer</li>
                    <li>Spesialis Computer Vision & Artificial Intelligence</li>
                </ul>
                </li>
                <li>
                <p className="font-semibold">Marvin Yonathan Hadiyanto, S.T., M.Sc. – Panelis Obstacle Robot</p>
                <ul className="list-disc pl-6">
                    <li>Dosen Teknik Elektro & Kepala Laboratorium Teknik Elektro UKRIDA</li>
                </ul>
                </li>
            </ul>

            <h3 className="text-xl font-semibold mt-6 mb-2">🔍 Penilaian yang Transparan dan Profesional</h3>
            <p className="mb-4">
                Para juri <b>IIT Challenge 2024</b> mengikuti pedoman penilaian yang ketat dan transparan. Mereka tidak hanya menilai berdasarkan hasil akhir, tetapi juga memperhatikan proses, kreativitas, dan relevansi solusi yang ditawarkan peserta.
            </p>

            <h3 className="text-xl font-semibold mb-2">👏 Terima Kasih untuk Para Juri</h3>
            <p className="mb-4">
                Kami mengucapkan terima kasih atas kontribusi besar para juri yang telah membantu memilih talenta terbaik dari ratusan peserta di seluruh Indonesia.
            </p>
        </div>
      );
      
};

export default ListJuriIIT2024;